'use strict'; // Shared by the real readonly SDK and the separately labelled local preview.
// Only server-confirmed activity progress selects the next step; no fallback1.

function limitedSteps(items, activity) {
  const rows = items.filter(p => p.kind === 'limited').slice().sort((a, b) => a.step - b.step);
  if (rows.length !== 6 || rows.some((p, i) => p.step !== i + 1)) throw Error('INVALID_LIMITED_STEPS');
  const valid = activity && activity.enabled === true && typeof activity.completed === 'boolean' && Number.isSafeInteger(activity.nextStep) && activity.nextStep >= 1 && activity.nextStep <= 7;
  const complete = !!valid && activity.completed;
  const current = valid && !complete && activity.nextStep <= 6 ? rows[activity.nextStep - 1] : null;
  return {
    rows: rows.map(p => ({ ...p,
      state: complete ? 'completed' : current ? p.step < current.step ? 'completed' : p.step === current.step ? 'current' : 'locked' : 'unpublished'
    })),
    current,
    complete
  };
}

function createLimitedRenderer(React) {
  const h = React.createElement;
  return function renderLimitedPackages({
    items,
    activity,
    readOnly = false,
    busy = false,
    quote = null,
    slogan,
    onChoose,
    onCheckout,
    onTab
  }) {
    const progress = limitedSteps(items, activity),
          current = progress.current,
          currentQuote = current && quote && quote.skuId === current.skuId ? quote : null;

    const formatMoney = q => new Intl.NumberFormat('zh-HK', {
      style: 'currency',
      currency: q.currency
    }).format(Number(q.amountMinor) / 100);

    const canChoose = !!current && !readOnly && !busy && activity.purchasingEnabled === true;
    return h(React.Fragment, null, h('section', {
      className: 'opcards-hero opcards-limited-hero'
    }, h('small', null, '限時典藏合輯'), h('h1', null, slogan), h('p', null, readOnly ? '卡包預覽 · 目前尚未開售或開放揭卡。' : '按順序購買第 1 至 6 步，每期每人一輪。')), h('div', {
      className: 'opcards-tabs'
    }, h('button', {
      type: 'button',
      disabled: busy,
      onClick: () => onTab('permanent'),
      'aria-pressed': false
    }, '常駐卡包'), h('button', {
      type: 'button',
      disabled: busy,
      onClick: () => onTab('limited'),
      'aria-pressed': true
    }, '限時合輯')), h('div', {
      className: 'opcards-step-scroll'
    }, h('ol', {
      className: 'opcards-step-track',
      'aria-label': '限時卡包六步進度'
    }, progress.rows.map(p => h('li', {
      key: p.skuId,
      className: 'opcards-step ' + p.state,
      'aria-current': p.state === 'current' ? 'step' : undefined
    }, h('span', {
      className: 'opcards-step-number'
    }, p.state === 'completed' ? '✓ ' + p.step : '第 ' + p.step + ' 步'), h('strong', null, p.paidPacks + ' 包'), p.giftPacks > 0 ? h('b', {
      className: 'opcards-step-gift'
    }, '送 ' + p.giftPacks + ' 包') : h('span', {
      className: 'opcards-step-spacer',
      'aria-hidden': true
    }, ' '), h('small', null, p.state === 'completed' ? '已完成' : p.state === 'current' ? '當前' : p.state === 'locked' ? '待解鎖' : '未開放'))))), progress.complete ? h('section', {
      className: 'opcards-limited-finished',
      role: 'status'
    }, h('strong', null, '本期六步已完成'), h('p', null, '本期每人限一輪；已取得的卡包可在「我的卡包」查看。')) : !current ? h('p', {
      className: 'opcards-progress',
      role: 'status'
    }, '尚未發佈活動排程；目前只供查看。') : h('section', {
      className: 'opcards-current-step'
    }, h('div', {
      className: 'opcards-current-detail'
    }, h('span', {
      className: 'opcards-foil',
      'aria-hidden': true
    }, 'OP'), h('div', null, h('small', null, '當前第 ' + current.step + ' 步'), h('strong', null, current.paidPacks + ' 卡包'), current.giftPacks > 0 && h('b', {
      className: 'opcards-bonus'
    }, '另贈 ' + current.giftPacks + ' 包'), h('span', null, current.name))), h('div', {
      className: 'opcards-current-action'
    }, h('strong', {
      className: 'opcards-current-price'
    }, currentQuote ? formatMoney(currentQuote) : readOnly ? '尚未開售' : '選擇後確認價格'), h('button', {
      type: 'button',
      className: 'opcards-primary',
      disabled: readOnly || busy || !currentQuote && !canChoose,
      onClick: () => currentQuote ? onCheckout() : onChoose(current)
    }, readOnly ? '尚未開售' : currentQuote ? '選擇付款方式' : '選擇第 ' + current.step + ' 步'))));
  };
}

module.exports = {
  limitedSteps,
  createLimitedRenderer
};
